import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { MDXProvider } from '@mdx-js/react';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import SocialIcon from '../SocialIcon';

export default () => (
  <StaticQuery
    query={graphql`
      {
        components: allFile(filter: {
          sourceInstanceName: {eq: "components"}, 
          childMdx: {frontmatter: {component: {eq: "socialplatforms"}}}
        }) {
          edges {
            node {
              childMdx {
                body
                fields {
                  locale
                }
              }
            }
          }
        }
      }
    `}
    render={({ components }) => {
      const { body } = components.edges[0].node.childMdx;

      return (
        <MDXProvider components={{ SocialIcon }}>
          <MDXRenderer>{body}</MDXRenderer>
        </MDXProvider>
      );
    }}
  />
);
